import { render, staticRenderFns } from "./CategoryDetail.vue?vue&type=template&id=d0364a6a&scoped=true&"
import script from "./CategoryDetail.vue?vue&type=script&lang=js&"
export * from "./CategoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./CategoryDetail.vue?vue&type=style&index=0&id=d0364a6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0364a6a",
  null
  
)

export default component.exports